<template>
  <div
    class="ce-selectFilter"
    :class="[{'is-open': isOpen }]">
    <div
      class="ce-selectFilter-toggle flex"
      @click="toggle">
      <div class="flex-auto">
        {{ label }}
        <span
          class="ms-2 ml1"
          v-if="activeOption">
          ("{{ activeOption.title }}")
        </span>
      </div>
      <div class="ce-selectFilter-toggleIndicator">
        <fa-icon :icon="['fas', 'angle-down']" />
      </div>
    </div>

    <div
      v-show="isOpen"
      class="ce-selectFilter-content">
      <ul class="list-reset">
        <li
          v-if="!hideAllOption"
          :class="{active: !activeOption}"
          @click="select(null)">
          {{ $t('filter.allLabel') }}
        </li>
        <li
          v-for="option in preparedOptions"
          :class="{active: activeOption && activeOption.code === option.code}"
          :key="option.code"
          @click="select(option.code)">
          {{ option.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropDownMixin from 'mixins/DropDown';
import { sortArray } from 'utils';

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    filterKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    hideAllOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      containerClass: 'ce-selectFilter'
    };
  },
  mixins: [DropDownMixin],
  computed: {
    ...mapGetters(['urlFilters']),
    activeOption() {
      return this.options.find((o) => o.selected);
    },
    preparedOptions() {
      return sortArray([...this.options], 'title', 'asc');
    }
  },
  methods: {
    select(value) {
      const url = this.$cloneObject(this.urlFilters);

      if (value) url[this.filterKey] = value;
      else delete url[this.filterKey];

      this.$store.dispatch('setUrlFilters', url).then(() => {
        this.close();
      });
    }
  }
};
</script>

<style lang="less">
@import (reference) "~styles/includes/base";

.ce-selectFilter {
  position: relative;
  margin-bottom: @space-3;

  .ce-selectFilter-toggle {
    background: @ce-filter-background-color;
    color: @ce-filter-color;
    font-weight: 600;
    padding: @space-2 @space-3;
    border-radius: 3px;
    cursor: pointer;
    .noselect();

    .ce-selectFilter-toggleIndicator {
      transition: transform 250ms ease;
      color: @ce-filter-highlight-color;
      padding-left: @space-2;

      svg {
        pointer-events: none;
      }
    }
  }

  &.is-open {
    .ce-selectFilter-toggle {
      .ce-selectFilter-toggleIndicator {
        transform: rotate(-180deg);
      }
    }
  }

  .ce-selectFilter-content {
    position: absolute;
    top: 100%;
    margin-top: @space-1;
    left: 0;
    width: 100%;
    background: @color-mono-95;
    z-index: 1000;
    color: @color-mono-20;
    border-radius: 3px;
    border: 2px solid darken(@ce-filter-background-color, 10);

    ul {
      margin: 0;

      li {
        padding: @space-2;
        cursor: pointer;
        color: @ce-filter-color;
        .noselect();

        &:hover, &.active {
          background: darken(@color-mono-95, 5);
        }
      }
    }
  }
}
</style>
